import "@fontsource-variable/inter/wght.css";
import "@fontsource-variable/geist/wght.css";
import "@fontsource-variable/figtree/wght.css";
import "@fontsource-variable/manrope/wght.css";
import "@fontsource/poppins/latin-300.css";
import "@fontsource/poppins/latin-300-italic.css";
import "@fontsource/poppins/latin-400.css";
import "@fontsource/poppins/latin-400-italic.css";
import "@fontsource/poppins/latin-500.css";
import "@fontsource/poppins/latin-500-italic.css";
import "@fontsource/poppins/latin-600.css";
import "@fontsource/poppins/latin-600-italic.css";
import "@fontsource/poppins/latin-700.css";
import "@fontsource/poppins/latin-700-italic.css";
import "@fontsource-variable/source-serif-4/wght.css";
import "@fontsource-variable/newsreader/wght.css";
import "@fontsource-variable/fraunces/wght.css";
import "@fontsource-variable/bricolage-grotesque/wght.css";
import "@fontsource-variable/geist-mono/wght.css";
import widgetFontLicenseUrl from "./widget-font-licenses.txt?url";
if (typeof document !== "undefined" && !document.head.querySelector("meta[name=pollen-widget-font-license]")) {
    const license = document.createElement("meta");
    license.name = "pollen-widget-font-license";
    license.content = widgetFontLicenseUrl;
    document.head.append(license);
}
//# sourceMappingURL=widget-font-assets.js.map